export class PageInitializer {
  private static instance: PageInitializer | null = null;
  private _isInitialized: boolean = false;

  private constructor() {
    // private constructorでnewの使用を防ぐ
  }

  public static getInstance(): PageInitializer {
    if (!PageInitializer.instance) {
      PageInitializer.instance = new PageInitializer();
    }
    return PageInitializer.instance;
  }

  public get isInitialized(): boolean {
    return this._isInitialized;
  }

  public ready(): Promise<void> {
    if (this._isInitialized) {
      return Promise.resolve();
    }

    return new Promise<void>((resolve) => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () =>
          this.handleReady(resolve)
        );
      } else {
        this.handleReady(resolve);
      }
    });
  }

  private handleReady(resolve: () => void): void {
    const promises: Promise<void>[] = [];

    // フォント読み込み処理
    if (document.fonts && 'ready' in document.fonts) {
      let fontTimeoutId: number;

      const fontTimeoutPromise = new Promise<void>((timeoutResolve) => {
        fontTimeoutId = window.setTimeout(() => {
          console.warn('フォント読み込みがタイムアウトしました（1000ms）');
          timeoutResolve();
        }, 1000);
      });

      const fontLoadingPromise = document.fonts.ready.then(() => {
        window.clearTimeout(fontTimeoutId);
        return;
      });

      promises.push(Promise.race([fontLoadingPromise, fontTimeoutPromise]));
    }

    // プリロード画像の読み込み処理
    const preloadImages = document.querySelectorAll<HTMLImageElement>('.js-global-preload');
    if (preloadImages.length > 0) {
      console.log('[PageInitializer] Found', preloadImages.length, 'preload images');

      const imagePromises = Array.from(preloadImages).map((img) => {
        return new Promise<void>((imageResolve) => {
          if (img.complete) {
            // 既に読み込み済み
            imageResolve();
          } else {
            // 読み込み完了を待つ
            img.addEventListener('load', () => imageResolve());
            img.addEventListener('error', () => {
              console.warn('[PageInitializer] Image failed to load:', img.src);
              imageResolve(); // エラーでも続行
            });
          }
        });
      });

      promises.push(Promise.all(imagePromises).then(() => undefined));
    }

    // すべての読み込みを待つ
    Promise.all(promises)
      .then(() => {
        this.completeInitialization();
        resolve();
      })
      .catch((error) => {
        console.error('リソース読み込み中にエラーが発生しました:', error);
        this.completeInitialization();
        resolve();
      });
  }

  private completeInitialization(): void {
    if (!this._isInitialized) {
      this._isInitialized = true;
    }
  }
}

export default PageInitializer;
